import { render } from "./LandingFooter.vue?vue&type=template&id=c3ba2e28&scoped=true"
import script from "./LandingFooter.vue?vue&type=script&lang=js"
export * from "./LandingFooter.vue?vue&type=script&lang=js"

import "./LandingFooter.vue?vue&type=style&index=0&id=c3ba2e28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3ba2e28"]])

export default __exports__